import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isEqual, isEmpty} from 'lodash';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import CustomTab, {CommonTab} from '../../../components/tab/CustomTab';
import TabGroup, {CommonTabGroup} from '../../../components/tab/TabGroup';
import CustomCard from '../../../components/card/CustomCard';
import AppointmentCard from './AppointmentCard';
import Input from '../../../components/form/Input';
import CustomButton, {DangerButton, SemiTransparentButton} from 'components/CustomButton';
import CustomModal from 'components/CustomModal';
import JobCardLoader from './JobCardLoader';
import BookCampaignForm from './BookCampaignForm';
import BookTimeSlot from './BookTimeSlot';

import {
  getCampaignInfo,
  assignCampaignJobToNurse,
  updateCamapignOrder,
  addAddress,
  bookCampaigns,
  getActiveNurses,
  getBookings,
  cancelBookings,
  getShifts, getCampaigns
} from 'redux/slices/nurseCampaignSlice';
import UpdateOrderForm from './updateOrder';
import Map from 'components/maps/GoogleMaps';
import Loader from '../../../components/Loader';
import AssignOrder from './AssignOrder';

import CustomCardHeader from "../../../components/card/CustomCardHeader";
import CardBody from "../../../components/card/CardBody";
import TableItemLoader from "../../../components/TableItemLoader";
import CustomIcon from "../../../components/CustomIcon";
import {Tag} from "../../../components/table/Status";
import ValueLabel from "../../../components/ValueLabel";
import FormLabel from "../../../components/form/FormLabel";
import {AddressModal} from "../../../components/address/AddressModal";
import Pagination from 'components/Pagination';

const CampaignJobs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {campaign_id} = useParams();

  const {
    bookings,
    campaigns, nurses,
    loading,
    error,
    totalPages,
    // address,
    loader,
    processing,
    shiftList
  } = useSelector((state) => state.campaign);


  const {
    address,
  } = useSelector((state) => state.address);


  const [activeModalComponent, setActiveModalComponent] = useState(null);
  const [activeCampaign, setActiveCampaign] = useState({});
  const searchParam = useLocation().search;

  const [activeTab, setActiveTab] = useState(tabItems[0]);
  const [showAddressForm, setAddressForm] = useState(false);
  const [selectedNurses, setSelectedNurses] = useState([]);
  const [page, setPage] = useState(1);

  const [selectedAppointmentIds, setSelectedAppointmentIds] = useState([]);
  const [selectedAppointment, setSelectAppointment] = useState({});

  const [modalData, setModalData] = useState(undefined);

  const [user, setSelectedUser] = useState({});

  const [addressList, setAddressList] = useState([]);

  const getJobs = {
    booked: (page) =>
      dispatch(
        getBookings({
          campaignId: campaign_id,
          status: 'BOOKED',
          page: page
        })
      ),
    assigned: (page) =>
      dispatch(
        getBookings({
          campaignId: campaign_id,
          status: 'ASSIGNED',
          page: page
        })
      ),
    completed: (page) =>
      dispatch(
        getBookings({
          campaignId: campaign_id,
          status: 'COMPLETED',
          page: page
        })
      )
  };

  const updateTab = (tab) => {
    if (!isEqual(tab, activeTab)) {
      setPage(1);
      setTabParams(tab, 1);
    }
  };

  useEffect(() => {
    //setting inital value if activeModalComponent is updatedOrder
    if (!isEmpty(selectedAppointment))
      setModalData({
        date: {
          value: selectedAppointment.appointment_date
        },
        quantity: selectedAppointment?.quantity.toString(),
        action: 'UPDATE',
        shift: shiftList?.find(
          (shift) => shift.id === selectedAppointment.shift_id
        )
      });
  }, [selectedAppointment]);

  useEffect(() => {
    dispatch(getCampaigns());
    const param = new URLSearchParams(searchParam);
    const page = param.get('page');
    const tabParamValue = param.get('tab');

    dispatch(getActiveNurses());
    setPage(page ?? 1);
    if (tabParamValue === tabItems[0].title) {
      setTabParams(tabItems[0], page);
    }
    if (tabParamValue === tabItems[1].title) {
      setTabParams(tabItems[1], page);
    }
    if (tabParamValue === tabItems[2].title) {
      setTabParams(tabItems[2], page);
    }
    dispatch(getShifts(campaign_id));
    dispatch(getCampaignInfo(campaign_id));
  }, []);

  const setTabParams = (tab, page) => {
    const url = new URL(window.location.href);
    setActiveTab(tab);
    navigate(`${url.pathname}?page=${page}&tab=${tab?.title}`, {
      replace: true
    });
    updatePageAndFetch(page, tab);
  };

  useEffect(() => {
    setModalData(undefined);
    setSelectAppointment({});
    setSelectedUser({});
    setActiveModalComponent(null);
    setSelectedNurses([]);
    setSelectedAppointmentIds([]);
  }, [bookings]);

  useEffect(() => {
    //update the new address to the list
    if (!isEmpty(address)) {
      setBookings({address: address}, modalData);
      setAddressList([address, ...addressList]);
    }
  }, [address]);
  useEffect(() => {
    setActiveCampaign(campaigns.find((campaign) => campaign.id === campaign_id));
  }, [campaigns]);

  const setBookings = (input, data) => {
    let bookings = {...data, ...input};
    setModalData(bookings);
  };

  const selectAppointments = (id, status = false) => {
    if (status) {
      let appointments = [...selectedAppointmentIds, id];
      setSelectedAppointmentIds(appointments);
    } else {
      let appointments = [...selectedAppointmentIds].filter(
        (selectedId) => selectedId !== id
      );
      setSelectedAppointmentIds(appointments);
    }
  };

  const updatedOrder = (keyValue, data) => {
    let order = {...data, ...keyValue};
    setModalData(order);
  };

  const AppointmentMapper = () => {
    return bookings?.map((booking, index) => (
      <AppointmentCard
        key={`${BOOKED_PREFIX}-${index}`}
        appointment={booking}
        setModalData={setModalData}
        activeTab={activeTab}
        setSelectAppointmentsIds={selectAppointments}
        setSelectAppointment={setSelectAppointment}
        selectedIds={selectedAppointmentIds}
        setActiveModalComponent={setActiveModalComponent}
        modalOption={ModalOptions}
        index={index}
      />
    ));
  };

  const updatePageAndFetch = (page, type) => {
    if (type === tabItems[0]) {
      getJobs.booked(page);
    } else if (type === tabItems[1]) {
      getJobs.assigned(page);
    } else {
      getJobs.completed(page);
    }
  };


  const ModalOptions = {
    timeSlots: {
      title: 'End Shift',
      child: () => <BookTimeSlot campaignId={campaign_id}/>,
      onComplete: () => null,
      validate: () => false,
      secondaryButtonLabel: "Close"
    },
    cancelBooking: {
      title: 'Cancel Bookings',
      child: ({modalData}) => (
        <Input
          type="text"
          color="blue"
          placeholder="Remark"
          value={modalData?.remarks ?? ''}
          onChange={(e) => {
            setModalData({remarks: e.target.value});
          }}
        />
      ),
      onComplete: ({modalData, processing, selectedAppointment}) => (
        <DangerButton
          disabled={
            processing || !ModalOptions.cancelBooking.validate(modalData)
          }

          onClick={() => {
            dispatch(
              cancelBookings({
                payload: {
                  remarks: modalData?.remarks,
                  action: 'CANCEL_JOB'
                },
                appointmentId: selectedAppointment.id,
                campaignId: campaign_id
              })
            );
          }}
        >
          Cancel Booking
        </DangerButton>
      ),
      validate: (data) => {
        return data?.remarks?.length > 5;
      }
    },
    bookCampaign: {
      title: 'Book Campaign',
      child: ({modalData, addressList}) => {
        return (
          <BookCampaignForm
            showMap={showMap}
            setBookings={setBookings}
            booking={modalData}
            setSelectedUser={setSelectedUser}
            addressList={addressList}
            setAddressList={setAddressList}
            campaignId={campaign_id}
          />
        );
      },
      onComplete: ({modalData}) => (
        <CustomButton
          disabled={processing || !ModalOptions.bookCampaign.validate(modalData) || !isCampaignAddressValid(modalData.address)}
          onClick={() => {
            let payload = {
              patient_id: modalData.userId,
              requested_for_id: modalData.userId,
              quantity: modalData?.quantity,
              appointment_date: modalData.appointment_date?.value,
              address_id: modalData.address?.id,
              shift_id: modalData?.shift?.id,
              campaign_id: campaign_id,
              source: 'WEB'
            };
            dispatch(bookCampaigns(payload));
          }}
        >
          Book
        </CustomButton>
      ),
      validate: (data) => {
        return (
          !isEmpty(data?.userId) &&
          !isEmpty(data?.quantity) &&
          !isEmpty(data?.appointment_date) &&
          !isEmpty(data?.address?.id) &&
          !isEmpty(data?.shift?.id)
        );
      }
    },
    assignOrder: {
      title: 'Assign Order',
      selectedNurses: [],
      child: ({selectedNurses}) => (
        <AssignOrder
          setSelectedNurses={setSelectedNurses}
          ModalOptions={ModalOptions}
          selectedNurses={selectedNurses}
        />
      ),
      onComplete: ({processing, selectedNurses}) => (
        <CustomButton
          disabled={
            processing || !ModalOptions?.assignOrder?.validate(selectedNurses)
          }
          onClick={() => {
            dispatch(
              assignCampaignJobToNurse({
                appointments: {
                  campaign_appointment_ids: selectedAppointmentIds,
                  nurse_ids: selectedNurses.map((nurse) => nurse.id)
                },
                activeTab
              })
            );
          }}
        >
          Assign
        </CustomButton>
      ),
      validate: (selectedNurses) => {
        return !isEmpty(selectedNurses);
      }
    },
    updateOrder: {
      title: 'Update Order',
      child: ({modalData, selectedAppointment}) => (
        <UpdateOrderForm
          updateOrder={updatedOrder}
          order={modalData}
          campaignId={campaign_id}
          selectedAppointment={selectedAppointment}
        />
      ),
      onComplete: ({modalData, processing, selectedAppointment}) => (
        <CustomButton
          disabled={processing || !ModalOptions.updateOrder.validate(modalData)}
          onClick={() => {
            let order = {
              remarks: modalData.remarks,
              appointment_date: modalData.date.value,
              shift_id: modalData?.shift?.id,
              quantity: modalData?.quantity
            };
            let oldOrder = {
              appointment_date: selectedAppointment.appointment_date,
              quantity: selectedAppointment?.quantity.toString(),
              action: 'UPDATE',
              shift_id: shiftList?.find(
                (shift) => shift.id === selectedAppointment.shift_id
              ).id
            };
            Object.entries(oldOrder).forEach(([k, v]) => {
              if (order[k] === v) {
                delete order[k];
              }
            });
            dispatch(
              updateCamapignOrder({
                campaignId: campaign_id,
                appointmentId: selectedAppointment.id,
                order
              })
            );
          }}
        >
          Update
        </CustomButton>
      ),
      validate: (data) => {
        return (
          !isEmpty(data?.date?.value.toString()) &&
          data?.remarks?.length > 5 &&
          !isEmpty(data?.quantity) &&
          !isEmpty(data?.shift?.id)
        );
      }
    }
  };

  const showMap = (status) => {
    setAddressForm(status);
  };

  const onCloseMap = () => {
    setAddressForm(false);
  };


  useEffect(() => {
    setAddressForm(false);
  }, [address]);

  useEffect(() => {
    if (loading) {
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.position = 'static';
    }
  }, [loading]);

  return (
    <>
      <div className="h-auto px-3 -mt-24 md:px-8">
        <div className="container max-w-full mx-auto">
          <div className="px-4 mb-16 grid grid-cols-1">
            {/*<CustomCard className="mb-12">*/}
            {/*  <CustomCardHeader contentPosition="none">*/}
            {/*    <div className="flex items-start justify-between w-full">*/}
            {/*      <div>*/}
            {/*        <h2 className="text-2xl text-white">{activeCampaign?.title}</h2>*/}
            {/*        <Tag label={activeCampaign?.type}/>*/}
            {/*      </div>*/}
            {/*      <div*/}
            {/*        className={`flex items-center ml-1 text-white  text-xs ${activeCampaign?.status ? "bg-primary-500" : "bg-error-500"} px-2 py-1 rounded-full`}>*/}
            {/*        <CustomIcon className="mr-1"*/}
            {/*                    icon={activeCampaign?.status ? "autorenew" : "do_not_disturb"}/>*/}
            {/*        {activeCampaign?.status ? "Ongoing" : "Inactive"}*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </CustomCardHeader>*/}
            {/*  <CardBody>*/}
            {/*    <div className="mb-2 font-medium">Campaign Info</div>*/}
            {/*    <div className="custom-card">*/}
            {/*      <ValueLabel label="Banners" value={*/}
            {/*        <div className="flex space-x-6">*/}
            {/*          <div className="flex-1">*/}
            {/*            <FormLabel label="Common Banner"/>*/}
            {/*            <div className="overflow-hidden rounded-md image-aspect-ratio">*/}
            {/*              <img src={activeCampaign?.banner_url} alt="" className="object-cover"/>*/}
            {/*            </div>*/}
            {/*          </div>*/}
            {/*          <div className="flex-1">*/}
            {/*            <FormLabel label="Booked Banner"/>*/}
            {/*            <div className="overflow-hidden rounded-md image-aspect-ratio">*/}
            {/*              <img src={activeCampaign?.booked_banner_url} alt="" className="object-cover "/>*/}
            {/*            </div>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*      }/>*/}
            {/*      <ValueLabel label="Description" value={activeCampaign?.description}/>*/}
            {/*      <ValueLabel label="Price" value={"NPR. " + activeCampaign?.price}/>*/}
            {/*    </div>*/}
            {/*  </CardBody>*/}
            {/*</CustomCard>*/}
            <CustomCard>
              <CustomCardHeader contentPosition="none">
                <div className="flex items-center justify-between w-full">
                  <div>
                    <h2 className="text-2xl text-white">{activeCampaign?.title} Bookings</h2>
                    <span
                      className={`inline-flex items-center justify-start text-white  text-xs ${activeCampaign?.status ? "bg-primary-500" : "bg-error-500"} px-2 py-1 rounded-full`}>
                      <CustomIcon className="mr-1"
                                  icon={activeCampaign?.status ? "autorenew" : "do_not_disturb"}/>
                      {activeCampaign?.status ? "Ongoing" : "Inactive"}
                    </span>
                  </div>
                  <div className="flex space-x-3">
                    <SemiTransparentButton
                      disabled={processing}
                      onClick={() => {
                        setActiveModalComponent(ModalOptions.timeSlots);
                        setModalData({});
                      }}>
                      Close Shift
                    </SemiTransparentButton>

                    <SemiTransparentButton
                      onClick={() => {
                        setActiveModalComponent(ModalOptions.bookCampaign);
                        setModalData({});
                      }}
                    >
                      Book Campaign
                    </SemiTransparentButton>


                  </div>
                </div>
              </CustomCardHeader>
              <CardBody>
                <div className="sticky top-0 left-0 right-0 bg-white">
                  <CommonTabGroup>
                    {tabItems.map((tab, i) => (
                      <CommonTab
                        key={`${KEY_PREFIX}${i}`}
                        onClick={() => updateTab(tab)}
                        disabled={false}
                        active={isEqual(activeTab, tab)}
                      >
                        {tab.title}
                      </CommonTab>
                    ))}
                  </CommonTabGroup>
                  {!isEmpty(selectedAppointmentIds) &&
                    <div className="absolute right-1.5 bottom-1.5">
                      <CustomButton
                        className="py-1"
                        disabled={isEmpty(selectedAppointmentIds)}
                        onClick={() => {
                          setSelectedNurses([]);
                          setActiveModalComponent(ModalOptions.assignOrder);
                          setModalData({});
                        }}

                      >Assign Person
                      </CustomButton>
                    </div>
                  }

                </div>
                {loading || isEmpty(bookings) || !isEmpty(error) ? (
                  <JobCardLoader
                    count={6}
                    keyName={activeTab.title}
                    loading={loading}
                    error={error.error}
                    isEmpty={isEmpty(bookings)}
                    retry={() => {
                      dispatch(getActiveNurses());
                      dispatch(getShifts(campaign_id));
                      dispatch(getCampaignInfo(campaign_id));
                      updatePageAndFetch(page, activeTab);
                    }}
                  />
                ) : (
                  <AppointmentMapper/>
                )}
                <Pagination 
                  pageCount={totalPages}
                  onPageChange={(data) => {
                    updatePageAndFetch(data.selected + 1, activeTab);
                    setPage(data.selected + 1);
                    setTabParams(activeTab, data.selected + 1);
                  }}
                  initialPage={page - 1}
                  forcePage={page - 1}
                />                

                <div className={`${showAddressForm ? 'hidden' : 'visible'}`}>
                  <CustomModal
                    showModal={modalData}
                    loading={processing}
                    setShowModal={() => {
                      setModalData(undefined);
                      setSelectAppointment({});
                      setSelectedUser({});
                      setActiveModalComponent(null);
                    }}
                    title={activeModalComponent?.title}
                    children={activeModalComponent?.child({
                      modalData,
                      selectedAppointment,
                      addressList,
                      selectedNurses
                    })}
                    button={activeModalComponent?.onComplete({
                      modalData,
                      processing,
                      selectedAppointment,
                      selectedNurses
                    })}
                    secondaryButtonLabel={activeModalComponent?.secondaryButtonLabel}
                  />
                </div>
                {
                  loader &&
                  <Loader/>
                }
              </CardBody>
            </CustomCard>
          </div>
        </div>
      </div>
      {
        showAddressForm &&
        <AddressModal showModal={showAddressForm} setShowModal={setAddressForm}
                      customerId={user.id} isCampaign={true}/>}

    </>
  );
};

export const tabItems = [
  {
    title: 'Booked',
    path: '/booked'
  },
  {
    title: 'Assigned',
    path: '/assigned'
  },
  {
    title: 'Completed',
    path: '/completed'
  }
];

const KEY_PREFIX = 'campaign';
const BOOKED_PREFIX = 'booked';


export const isCampaignAddressValid = (address) => {
  return address?.area?.campaign_location && address?.province?.campaign_location && address?.city?.campaign_location
}

export default CampaignJobs;
